export default function Summer(props: any) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3227_81895)">
                <path d="M3.0498 3.05029L3.79227 3.79277" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1 8H2.05" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.0498 12.95L3.79227 12.2075" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.9505 12.95L12.208 12.2075" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.0002 8H13.9502" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.9505 3.05029L12.208 3.79277" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 1V2.05" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79087 10.2091 4 8 4C5.79087 4 4 5.79087 4 8C4 10.2091 5.79087 12 8 12Z"
                    stroke="#333333"
                    strokeWidth="1.33333"
                    strokeLinejoin="round"
                />
                <path d="M8 15.0002V13.9502" stroke="#333333" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3227_81895">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
